<template>
  <div>
    <!-- 普通公告 -->
    <el-dialog v-if="showType == 2" class="main-message-dialog" width="800px" :title="noticeData.title" append-to-body :visible.sync="showDialog" :close-on-click-modal="false" @close="() => closeDialog()">
      <div v-if="noticeData.backgroundImage" class="dialog-bg" :style="{ background: `url(${noticeData.backgroundImage})`, backgroundSize: '100% 100%' }"></div>
      <div v-else class="dialog-bg" style="background: #fff"></div>

      <div id="messageDiv" class="message-dialog max">
        <div v-if="noticeData.messageType === 2">
          <img v-if="!noticeData.redirectLink" :src="noticeData.messageContent" />
          <a v-else :href="noticeData.redirectLink"><img :src="noticeData.messageContent" /></a>
        </div>

        <div v-else v-html="noticeData.messageContent"></div>
      </div>
      <div class="footer-btn">
        <template>
          <el-checkbox v-model="checked" style="margin-right: 16px">{{ noticeData.checkboxText || '下次不再提醒' }}</el-checkbox>
          <el-button size="small" type="primary" key="disabled" :style="buttonCss || ''" @click="() => closeDialog(true, 1)">{{ noticeData.acknowledgeButtonText || '我知道了' }}</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 协议公告 -->
    <div class="office-box" :class="showOffice ? 'show' : ''" v-if="showType == 4">
      <div class="office-content">
        <div class="office-title">
          {{ noticeData.title }} <span class="close" @click="() => closeDialog()"><i class="el-icon-close"></i></span>
        </div>
        <div ref="officeRef" id="officeRef"></div>
        <div class="footer-office">
          <template v-if="!isAdmin">
            <span style="color: red; padding-right: 16px">您不是管理员，没有权限进行签署，请尽快联系管理员进行操作！</span>
            <el-button size="small" type="primary" :style="buttonCss || ''" @click="() => closeDialog()">{{ noticeData.acknowledgeButtonText || '关闭' }}</el-button>
          </template>

          <template v-else-if="isAdmin">
            <el-checkbox v-model="checked" style="margin-right: 16px">{{ noticeData.checkboxText || '签署协议' }}</el-checkbox>
            <el-button size="small" type="primary" :style="buttonCss || ''" :disabled="!checked" @click="() => closeDialog(true, 2)">{{ noticeData.acknowledgeButtonText || '确认并签署' }}</el-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import office from '@/api/web-office-sdk-solution-v2.0.5.es.js'
import { fetchNoticeList, updateNoticeConfig, getWebOffice, fetchNoticeRead, fetchProtocolRead } from '@/api/user'
import { PRODUCTCODES } from '@/utils'
import moment from 'moment'

export default {
  name: 'Announce',
  props: {
    isAdmin: Boolean
  },
  data() {
    return {
      noticeData: {},
      buttonCss: null,
      showType: 4, // 1-红点提醒  2-公告提醒   3-站内提醒   4-强公告提醒
      showDialog: false,
      showOffice: false,
      checked: false,

      // office
      imgType: false,
      instance: {},
      subName: ''
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'childName'])
  },
  watch: {
    isLogin() {
      if (this.$store.getters.isLogin) {
        const arr = location.pathname.split('/')
        if (arr[1] == 'cps') {
          this.subName = 'shcps'
        } else if (arr[1] === 'cpsqd') {
          this.subName = 'qdcps'
        } else if (arr[1] == 'track') {
          this.subName = 'shTrack'
        } else {
          this.subName = arr[1]
        }
        console.log('第一次进页面或刷新页面触发：已登录（调用获取公告接口）', this.subName)
        this.getNotice()
      }
    },
    childName: {
      // 监听子组件是否变化，如果改变，则重新获取通知
      handler(newPath, oldPath) {
        if (newPath != oldPath && this.isLogin) {
          if (newPath === 'cps') {
            this.subName = 'shcps'
          } else if (newPath == 'cpsqd') {
            this.subName = 'qdcps'
          } else {
            this.subName = newPath
          }
          console.log('切换子组件触发，调用获取公告接口', newPath)
          this.getNotice()
        }
      },
      deep: true
    }
  },

  mounted() {},
  unmounted() {
    this.instance && this.instance.destroy()
  },

  methods: {
    // 初始化Office
    async initOffice(fileUrl) {
      // fileUrl = 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/temp/%E4%BA%A7%E7%A0%94%E9%A1%B9%E7%9B%AE%E5%BC%80%E5%8F%91%E6%B5%81%E7%A8%8B%E8%A7%84%E8%8C%83.docx'
      const res = await getWebOffice(fileUrl)
      const config = res.data || {}
      if (res.data.officeType) {
        const officeSdk = office.init({
          ...config,
          customArgs: {
            readonly: true
          },
          mode: 'simple',
          mount: document.getElementById('officeRef'),
          wordOptions: {
            isShowDocMap: false, // 是否开启目录功能，默认开启
            isBestScale: true // 打开文档时，默认以最佳比例显示
          }
        })
        this.instance = officeSdk
      }
    },

    // 获取公告内容
    async getNotice() {
      const resp = await fetchNoticeList({
        isRead: 0,
        showType: this.showType,
        pageNum: 1,
        pageSize: 100
      })
      if (resp.success) {
        let data = []
        resp.data.records.map(d => {
          // 已读次数未达到设置的次数，当前时间小于推送截止时间
          // 未指定业务类型 - 所以业务都弹窗提醒
          // 指定业务类型 - 只在对于子业务项目弹窗提醒
          if ((d.productId === '' || d.productId.indexOf(this.subName) !== -1) && d.reminderCount < d.reminderConfCount && d.reminderEnd && moment().valueOf() < moment(d.reminderEnd).valueOf()) {
            data.push(d)
          }
        })

        // console.log('获取公告内容前', data)

        // 如果有未读强公告
        if (this.showType === 4 && data.length > 0) {
          const item = data[0]
          this.checkNoticeShow(item, 4)
        }

        // 如果没有未读强公告，则获取普通公告
        else if (this.showType === 4 && data.length === 0) {
          this.showType = 2
          this.getNotice()
        }

        // 如果有未读普通公告
        else if (this.showType === 2 && data.length > 0) {
          const item = data[0]
          this.checkNoticeShow(item, 2)
        }
      }
    },

    // 检查是否显示公告
    async checkNoticeShow(item, type) {
      let isShow = false

      // 如果指定推送业务公告，则跳过公告弹窗功能
      if (item.productId) {
        const host = location.host
        const pathname = host + location.pathname
        const codes = item.productId.split(',')

        // 检查当前路由是否与设置的业务类型CODE匹配（开通/未开通路由）
        codes.map(code => {
          try {
            if (pathname.indexOf(host + PRODUCTCODES[code].pathLogin) !== -1 || pathname.indexOf(host + PRODUCTCODES[code].pathNotLogin) !== -1) isShow = true
          } catch (error) {
            console.log('业务类型CODE不匹配', code, pathname)
          }
        })
      }
      // 未指定业务类型，全部显示
      else {
        isShow = true
      }

      if (isShow && item.reminderCount < item.reminderConfCount) {
        if (item.acknowledgeButtonCss) {
          this.buttonCss = JSON.parse(item.acknowledgeButtonCss)
        } else {
          this.buttonCss = null
        }

        this.noticeData = item

        // 协议公告需要引入office
        if (type === 4) {
          this.showOffice = true
          document.getElementById('officeRef').innerHTML = ''
          await this.initOffice(item.messageContent)
        }
        // 普通公告
        else if (type === 2) {
          this.showDialog = true
        }
        this.updateNotice(item.id)
      }
    },

    // 更新提醒次数
    async updateNotice(id) {
      const resp = await updateNoticeConfig(id)
    },

    // 设置消息已读
    async setReadStatus() {
      const id = this.noticeData.id
      const resp = await fetchNoticeRead([id], 'read')
      if (resp.success) {
        this.getNotice()
      }
    },

    // 设置协议消息已读
    async setProtocolReadStatus() {
      const id = this.noticeData.id
      const resp = await fetchProtocolRead(id)
      if (resp.success) {
        this.getNotice()
      }
    },

    // 关闭弹窗
    closeDialog(bool, type) {
      // 点击确定按钮设置消息状态为已读
      if (bool && this.checked) {
        type == 1 ? this.setReadStatus() : this.setProtocolReadStatus()
      }

      this.showDialog = false
      this.showOffice = false
      this.checked = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
